import { IPlaylistResponseDto } from "./PlaylistsTypes";

export interface MediaLibraryConfig {
    libraryId: 1;
    fetchByDate?: boolean;
    filterControls?: boolean;
    ratingControls?: boolean;
    shareControls?: boolean;
    mediaPerPage?: number;
    enabled?: boolean;
    analytics?: boolean;
    showPlaylists?: boolean;
    hideDefaultVOD?: boolean;
    enableCompetitionMode?: boolean;
    enableAutoplay?: boolean;
    tabControls?: boolean;
    disableFullscreenPlayer?: boolean;
    enableDarkMode?: boolean;
}

export interface StreamLibraryConfig {
    libraryId: 2;
    enabled?: boolean;
    tabControls?: boolean;
    shareControls?: boolean;
}

export enum BlockType {
    GENERAL_VOD = 0,
    FILM_FESTIVAL_VOD = 1,
    LIVE_STREAMS = 2,
    PLAYLIST = 3,
    AD = 4,
}


export interface Block {
    blockId: string;
    versionId: string;
    profileId: string;
    type: BlockType;
    enabled: boolean;
    renderInfo: {
        templateId?: number;
        mobileTemplateId?: number;
        playlistId?: string;
    };
    payload?: any | IPlaylistResponseDto;
    createdAt: string;
    updatedAt: string;
}

export interface BlockTemplate {
    blockType: BlockType;
    key: string;
    value: string;
}

export interface BlockCollectionConfig {
    clientId: string;
    order: Block[];
    templateIds: BlockTemplate[];
}

export interface LibraryOutlet {
    profileId: string;
}

export interface Profile {
  profileId: string;
  clientId: string;
  profileName: string;
  active: boolean;
  deleted: boolean;
  deletedAt: string | null;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  versionCount?: number;
}

export interface Version {
  versionId: string;
  profileId: string;
  versionName: string;
  isActive: number;
  blockCount?: number;
  blocksOrder: string[];
  createdAt: string;
  updatedAt: string;
}


export interface LoadedProfileResponseDto {
    profile: Profile;
    blocks: Block[];
    version: Version; 
}